import { isCurrencyCodeString } from 'pricing-pages-ui-components/currency/types';
/* Parse a purchase option's per-month price, returning undefined for a missing
 * option or an unparseable/empty value so callers can skip it. */
function parseMonthlyPrice(option) {
  if (!option) {
    return undefined;
  }
  const price = Number(option.monthlyPrice);
  if (option.monthlyPrice.trim() === '' || !Number.isFinite(price)) {
    return undefined;
  }
  return price;
}

/* Resolve the per-month price a tier should show for the selected term. Prefer
 * the selected term, then fall back to any other term that carries a usable
 * price. Generalizing over the term set (instead of enumerating ANNUAL/MONTHLY
 * preference lists) keeps a monthly-only tier (STARTER) showing its monthly
 * price on the annual toggle and an annual-only tier (ENTERPRISE) showing its
 * annual price on the monthly toggle. Mirrors v1's usePerMonthPriceForTerm,
 * which resolves annualPrice || monthlyPrice regardless of requested term.
 *
 * This is the tier's pricing business logic, kept out of the presentational
 * card: the merch card only ever receives the resolved number to render. */
export function resolveHsocTierPrice(pricing, selectedTerm) {
  if (!pricing) {
    return undefined;
  }
  const selectedPrice = parseMonthlyPrice(pricing.purchaseOptions[selectedTerm]);
  if (selectedPrice !== undefined) {
    return selectedPrice;
  }
  for (const option of Object.values(pricing.purchaseOptions)) {
    const price = parseMonthlyPrice(option);
    if (price !== undefined) {
      return price;
    }
  }
  return undefined;
}
export function buildHsocPriceDisplay(pricing, selectedTerm, currencyCode, tierName) {
  if (!isCurrencyCodeString(currencyCode)) {
    return undefined;
  }
  const resolvedCurrencyCode = currencyCode;

  /* The FREE tier has no purchase options; mirror the public pages and show an
   * explicit $0 rather than no price. */
  if (tierName === 'FREE') {
    return {
      price: 0,
      currencyCode: resolvedCurrencyCode
    };
  }
  const price = resolveHsocTierPrice(pricing, selectedTerm);
  if (price === undefined) {
    return undefined;
  }
  return {
    price,
    currencyCode: resolvedCurrencyCode
  };
}
export function hasMultipleBillingTerms(productsByTier) {
  if (!productsByTier) {
    return false;
  }
  return Object.values(productsByTier).some(tier => Object.keys(tier.pricing.purchaseOptions).length > 1);
}